import { RuleResult } from '../../../../types/DeclarationP5'

const C0945Validator = {
  validatePlaceOfUnloadingRequirement: ({
    security,
    additionalDeclarationType,
  }: {
    security: string
    additionalDeclarationType: string
  }): RuleResult => {
    if (['1', '3'].includes(security)) {
      return additionalDeclarationType === 'D' ? 'OPTIONAL' : 'REQUIRED'
    }

    return security === '0' ? 'NOT_ALLOWED' : 'OPTIONAL'
  },
}

export default C0945Validator
